import { Button, Modal } from '@mairistem/composants';
import React from 'react';
import useModalSuperUserValidation from '../../../../../hooks/useModalSuperUserValidation';

interface MouvementDeleteModalProps {
	onChange: VoidFunction;
	onClose: VoidFunction;
	visible: boolean;
	isSuperUser: boolean;
}

const MouvementDeleteModal = ({
	onChange,
	onClose,
	visible,
	isSuperUser,
}: MouvementDeleteModalProps) => {
	const { isValidated, validationComponent } = useModalSuperUserValidation();

	const handleClick = (): void => {
		onChange();
		onClose();
	};
	return (
		<Modal open={visible} data-testid="mouvementDeleteModal">
			<Modal.Header>Suppression du mouvement</Modal.Header>
			<Modal.Content>
				<p>Êtes-vous sûr de vouloir supprimer ce mouvement ?</p>
				{isSuperUser && validationComponent}
			</Modal.Content>
			<Modal.Actions>
				<Button onClick={onClose} data-testid="mouvementDeleteActionCancel">
					Annuler
				</Button>
				<Button
					primary
					onClick={handleClick}
					disabled={isSuperUser && !isValidated}
					data-testid="mouvementDeleteActionConfirm"
				>
					Supprimer
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default MouvementDeleteModal;
